export default function isStringOnlyWithLatinLetters(value) {
    const hasOnlyLetters = !!value.match(/^[a-z]*$/i);

    if (value != "" && !hasOnlyLetters) {
        return false; 
    }
    return true;
}